import React, { useState, useEffect } from 'react';
import axios from "axios";
import { BASELINE } from "../../util/index";
import { FaFilePdf } from "react-icons/fa";
import { useParams } from 'react-router-dom';

const SatAnswers = () => {
    const { folderType } = useParams();
    const [pdfFiles, setPdfFiles] = useState([]);
    const [selectedPdf, setSelectedPdf] = useState(null);

    // 특정 filename PDF를 불러와서 setSelectedPdf에 저장
    const fetchPdfContent = (filename) => {
        axios.get(`${BASELINE}digital/sat/answer/${folderType}/${filename}`)
            .then(response => {
                setSelectedPdf(response.data); // { filename, content(=base64) }
            })
            .catch(error => {
                console.error("Error fetching PDF:", error);
            });
    };

    // folderType 변경될 때마다 PDF 리스트를 가져옴
    // 가져온 뒤, 첫 번째 PDF가 있으면 자동으로 fetchPdfContent 호출
    useEffect(() => {
        axios.get(`${BASELINE}digital/sat/answers/${folderType}`)
            .then(response => {
                const dataArr = response.data[folderType] || [];
                setPdfFiles(dataArr);
                if (dataArr.length > 0) {
                    // 첫 번째 PDF 자동 로드
                    fetchPdfContent(dataArr[0].title);
                }
            })
            .catch(error => console.error("Error fetching PDF files:", error));
    }, [folderType]);

    // 왼쪽 리스트를 클릭하면 해당 PDF 로드
    const handlePdfClick = (filename) => {
        fetchPdfContent(filename);
    };

    return (
        <div className="p-8 bg-white">

            {/* 2:8 레이아웃 구성 */}
            <div className="grid grid-cols-10 gap-4">
                {/* 왼쪽(2) - PDF 리스트 */}
                <div className="col-span-2 bg-gray-50 p-4 rounded-md h-[80vh] overflow-y-auto">
                    {pdfFiles.map((file, index) => (
                        <div
                            key={index}
                            className="bg-white rounded-lg shadow p-2 mb-2 cursor-pointer hover:bg-gray-100 transition duration-300 flex items-center"
                            onClick={() => handlePdfClick(file.title)}
                        >
                            <FaFilePdf className="w-6 h-6 text-red-500 mr-2" />
                            <p className="text-gray-900 truncate">{file.title}</p>
                        </div>
                    ))}
                </div>

                {/* 오른쪽(8) - 선택된 PDF 뷰어 */}
                <div className="col-span-8 bg-gray-100 rounded-md p-4 relative">
                    {selectedPdf ? (
                        <>
                            {/* PDF 파일명 표시 */}
                            <h3 className="text-xl font-semibold mb-4">
                                {selectedPdf.filename}
                            </h3>
                            {/* PDF 뷰어 (Base64로 인라인) */}
                            <iframe
                                src={`data:application/pdf;base64,${selectedPdf.content}`}
                                title="PDF Preview"
                                className="w-full h-[700px] border rounded-md"
                            />
                        </>
                    ) : (
                        <p className="text-gray-500">No PDF selected.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SatAnswers;
